module.exports = "data:image/png;base64,UklGRvQAAABXRUJQVlA4WAoAAAAQAAAAPwAAPwAAQUxQSFEAAAABJ6CQbQQ4lZ3ScXwRETwWGDSyFecRDJwGCAb+/2Cgh39dXQFNIvo/AdJ8wSbJN9pVNpyMyk71oNbGD/X8H2w8qHVRw6hcqCRnuqT5vJ+fJgEAVlA4IHwAAADwBgCdASpAAEAAPpFImkqlpKIhpBgLaLASCWkAAAy5iWCqHs++2P2yfHJ+RK1pS8/vtDzjTJOTWPaOCB+5j2WAAP77kz3hlHVRZEE7sdtMfTZgtwLzYSDsCghflV1l6XgBbm5FN95tvp6/hTCM5y+X/+S+cLgvbF84AAAA"


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/RegularNode_body.png
// module id = 11
// module chunks = 0